package com.anjuros.website.redesign.sections.home

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.redesign.components.RdLink
import com.anjuros.website.redesign.components.RdSection
import com.anjuros.website.redesign.components.RdSectionHead
import com.anjuros.website.redesign.styles.HomeTradeAllStyle
import com.anjuros.website.redesign.styles.HomeTradeLinkStyle
import com.anjuros.website.redesign.styles.HomeTradesGridStyle
import com.anjuros.website.redesign.styles.RdSectionFlushTopStyle
import com.anjuros.website.redesign.styles.RdSectionStyle
import com.anjuros.website.redesign.util.RdRoute
import com.anjuros.website.redesign.util.RdText
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.Nav
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

private val TradeLinks = listOf(
    RdText.TRADE_ELECTRICIANS to RdRoute.ELECTRICIAN,
    RdText.TRADE_DECORATORS to RdRoute.DECORATOR,
    RdText.TRADE_HANDYMEN to RdRoute.HANDYMAN,
    RdText.TRADE_HAIRDRESSERS to RdRoute.HAIRDRESSER,
    RdText.TRADE_DOG_WALKERS to RdRoute.DOG_WALKER,
    RdText.TRADE_BAKERS to RdRoute.BAKER,
    RdText.TRADE_INSTRUCTORS to RdRoute.INSTRUCTOR,
)

/** Links to every trade page, which also helps those pages rank. */
@Composable
fun HomeTradesSection() {
    val navLabel = LocalText(RdText.HOME_TRADES_NAV_LABEL)
    RdSection(
        id = "trades",
        labelledBy = "trades-h",
        modifier = RdSectionStyle.toModifier().then(RdSectionFlushTopStyle.toModifier()),
    ) {
        RdSectionHead(RdText.HOME_TRADES_EYEBROW, "trades-h", RdText.HOME_TRADES_TITLE, RdText.HOME_TRADES_LEDE)
        Nav(
            HomeTradesGridStyle.toModifier()
                .attrsModifier { attr("aria-label", navLabel) }
                .toAttrs()
        ) {
            TradeLinks.forEach { (text, path) -> TradeLink(text, path) }
            TradeLink(RdText.TRADE_ALL, RdRoute.TRADES, HomeTradeAllStyle.toModifier())
        }
    }
}

@Composable
private fun TradeLink(text: RdText, path: String, extra: Modifier = Modifier) {
    RdLink(path, HomeTradeLinkStyle.toModifier().then(extra)) {
        Text(LocalText(text))
        Span { Text("→") }
    }
}
